import React from 'react';

import './App.css';
// import Header from './component/Header';
import Home from './component/Home2'
// import HomeInsta from './component/HomeInsta'
// import Home2 from './component/Home2'
import Header from './component/Header'
import Footer from './component/Footer';
import AddDeals from './component/AddDeals'
import EditDeals from './component/EditDeals';
import DealDetail from './component/DealDetail'
import Store from './component/Store'
import Category from './component/Category'
import Update from './component/Update'
import Login from './component/Login'
import Registration from './component/Registration'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Dashboard from './Private_page/Dashboard';
import Private from './Private_page/Private';
// old: import EditSubDeal from './component/EditSubDeal';
// new: (EditSubDeal.js is kept in the project but not used; Netlify fails on unused imports)
import EditSubDealPage from './component/EditSubDealPage';
import AddCategory from './component/AddCategory';
import ResetPassword from './component/ResetPassword';
import Search from './component/Search';
import ContactUs from './component/ContactUs';
import Blognav from './component/Blog/Blognav';
import Prime from './component/Blog/Prime'
import Pogopass from './component/Blog/Pogopass'
// import axios from 'axios';
import PrivacyPolicy from './component/PrivacyPolicy';
import NotFound from './component/NotFound';
import ServerWakeBanner from './component/ServerWakeBanner';

function App() {
  return (


  
    <div className='app'>

      <BrowserRouter >

        <Header />
        <ServerWakeBanner />
        <Routes>


          <Route exact path="/login" element={<Login />} ></Route>
          <Route exact path="/registration" element={<Registration />}></Route>
          <Route exact path="/" element={<Home />} />

          <Route exact path="/store/:store" element={<Store />} />
          <Route exact path="/category/:category" element={<Category />} />
          <Route exact path="/ContactUs" element={<ContactUs />} />
          <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route exact path="/search/:searchstring" element={<Search />} />
          <Route exact path="/update" element={<Update />} />
          <Route exact path="/deal/:id/:commondiscription" element={<DealDetail />} />
          <Route exact path="/blog" element={<Blognav />} />
          <Route exact path="myblog/primeday" element={<Prime />} />
          <Route exact path="myblog/pogopass" element={<Pogopass />} />
          
          <Route exact path="/user" element={<Private />}>
            <Route exact path="dashboard" element={<Dashboard />} />
            <Route exact path="adddeals" element={<AddDeals />} />
            <Route exact path="editdeals" element={<EditDeals />} />
            {/* old: <Route exact path="editsubdeals/:id" element={<EditSubDeal />} /> */}
            {/* new: finished edit/delete page for sub-deals (EditSubDeal.js is kept but not used) */}
            <Route exact path="editsubdeals/:id" element={<EditSubDealPage />} />
            <Route exact path="addcategory" element={<AddCategory />} />
            <Route exact path="resetpassword" element={<ResetPassword />} />

          </Route>

          <Route path="*" element={<NotFound />} />

        </Routes>
        {window.location.pathname !== '/login' && window.location.pathname !== '/user/dashboard' && <Footer />}
      </BrowserRouter>
      
      
      
      </div>
   

      
  );
}

export default App;
